import { IOrderStatus } from "../interfaces/order";
import {
  CANCELED,
  DELIVERED,
  IN_PROCESS,
  IN_PROCESS_TO_RETURN,
  IN_TRANSIT_WITHDRAWAL,
  PENDING,
  PENDING_PICKUP_RETURN,
  PENDING_RETURN,
  PENDING_WITHDRAWAL,
  RETURNED,
  RETURNED_TO_SENDER,
} from "./constants";

export const ALLOWED_OWN_FLEET_ORDER_DOOR_TO_DOOR_STATUS_TRANSITIONS: {
  [key: string]: string[];
} = {
  [PENDING]: [IN_PROCESS, CANCELED, RETURNED_TO_SENDER, DELIVERED],
  [IN_PROCESS]: [DELIVERED, RETURNED_TO_SENDER],
  [DELIVERED]: [PENDING_RETURN, RETURNED],
  [PENDING_RETURN]: [RETURNED],
  [RETURNED]: [],
  [RETURNED_TO_SENDER]: [],
  [CANCELED]: [],
};

export const ALLOWED_OWN_FLEET_ORDER_REVERSE_LOGISTICS_STATUS_TRANSITIONS: {
  [key: string]: string[];
} = {
  [PENDING_WITHDRAWAL]: [IN_TRANSIT_WITHDRAWAL,IN_PROCESS_TO_RETURN, CANCELED, RETURNED],
  [IN_TRANSIT_WITHDRAWAL]: [IN_PROCESS_TO_RETURN, RETURNED],
  [IN_PROCESS_TO_RETURN]: [RETURNED],
  [RETURNED]: [],
  [CANCELED]: [],
};

export const ALLOWED_OWN_FLEET_ORDER_REVERSE_LOGISTICS_PICKUP_STATUS_TRANSITIONS: {
  [key: string]: string[];
} = {
  [PENDING_PICKUP_RETURN]: [IN_PROCESS_TO_RETURN, CANCELED],
  [IN_PROCESS_TO_RETURN]: [RETURNED],
  [RETURNED]: [],
  [CANCELED]: [],
};

export const ALLOWED_OWN_FLEET_STATUS_TRANSITIONS: {
  [key: string]: { [key: string]: string[] };
} = {
  DOOR_TO_DOOR: ALLOWED_OWN_FLEET_ORDER_DOOR_TO_DOOR_STATUS_TRANSITIONS,
  REVERSE_LOGISTICS:
    ALLOWED_OWN_FLEET_ORDER_REVERSE_LOGISTICS_STATUS_TRANSITIONS,
  REVERSE_LOGISTICS_PICKUP:
    ALLOWED_OWN_FLEET_ORDER_REVERSE_LOGISTICS_PICKUP_STATUS_TRANSITIONS,
};

export const hasAvailableStatusTransition = (
  service: string,
  status: string,
  isOwnFleet: boolean
): boolean => {
  if (!isOwnFleet) return true;
  return (
    Object.keys(ALLOWED_OWN_FLEET_STATUS_TRANSITIONS[service]).includes(
      status
    ) && ALLOWED_OWN_FLEET_STATUS_TRANSITIONS[service][status].length > 0
  );
};

export const isValidStatusTransition = (
  statusOption: IOrderStatus,
  isOwnFleet: boolean,
  service: string,
  status: string
): boolean => {
  // Only filter for Own Fleet
  if (!isOwnFleet) return true;

  return (
    ALLOWED_OWN_FLEET_STATUS_TRANSITIONS[service][status]?.includes(
      statusOption.id
    ) || false
  );
};
